import { BaseEntity } from "./base";

export class Report extends BaseEntity {  
  name: string;
  title: string; 
  columns: any[];
}